import React, { useState } from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import blockchain from "../assets/images/blockchain.png"
import card from "../assets/images/card.png"
import security from "../assets/images/security.png"
import virtual from "../assets/images/virtual-reality.png"

import "../styles/home.css";
import EccosystemCard from "../components/EccosystemCard";
import GrTitle, { Title } from "../components/BgTitle";
import {Fade} from "react-reveal";
import TokenDetailSection from "../components/tokenomics/TokenDetialSection";
import useWindowDimensions from "../constatns/size";

function Eccosystem() {

    const { width, height } = useWindowDimensions();
    const [isUser, setIsUser] = useState(true);

  return (
      <div id="eccosystem">
            <GrTitle bgTitle={"WEB 3.0 BLOCKCHAIN"} />
            <Title title={"ECOSYSTEM"} />
        
        <Container width={width} height={height}>
            <InnerContainer>
            <Fade top >
                <EccosystemCard
                    id={"1"}
                    image={blockchain}
                    title={"SCM by Blockchain"}
                    description={"GearChain gives individuals and businesses access to trustless verification of their physical assets with blockchain."}
                />
            </Fade>
            <Fade top >
                <EccosystemCard
                    id={"2"}
                    image={card}
                    title={"Domain Expertise"}
                    description={"Implemented by experts in inventory management."}
                />
            </Fade>
            <Fade top >
                <EccosystemCard
                    image={security}
                    id={"3"}
                    title={"Growing Ecosystem"}
                    description={"Blockchain-based digital assets with an upward value curve."}
                />
            </Fade>
            <Fade top >
                <EccosystemCard
                    image={virtual}
                    id={"4"}
                    title={"Multiple Income Streams"}
                    description={"The SaaS platform's revenue model includes buying the DApp with fiat and earning rewards in tokens."}
                />
            </Fade>
            </InnerContainer>
            <ButtonBar width={width}>
               <ButtonBarSection style={{color: isUser ? colors.white : colors.btnPrimary, backgroundColor: isUser ? colors.btnPrimary : "transparent"}}
                onClick={()=>{ setIsUser(true) }}
               >
                    End User
                </ButtonBarSection>
                <ButtonBarSection style={{color: isUser ? colors.btnPrimary : colors.white, backgroundColor: isUser ? "transparent" : colors.btnPrimary}}
                    onClick={()=>{setIsUser(false)}}
                >
                    Admin
                </ButtonBarSection>
            </ButtonBar>
            {
                isUser ?
                <DetailBoxContainer>
                    <DetailBox>
                        <MainHeading>
                        Customizable Inventory and SCM app builder
                        </MainHeading>
                        <DetailSection>
                            <TokenDetailSection
                                description={"Anyone can build custom inventory app without any coding knowledge."}
                            />
                            <TokenDetailSection
                                description={"Build an inventory project for any size from household, small, medium or multiple sites."}
                            />
                            <TokenDetailSection
                                description={"User scans barcodes with a mobile phone and updates key inventory data in just a few clicks."}
                            />
                            <TokenDetailSection
                                description={"The app can be utilized for customer reporting purposes since it is integrated with Google Sheets."}
                            />
                            <TokenDetailSection
                                description={"GearChain blockchain allows for instant entry speeds with a high transaction per second (TPS)."}
                            />
                        </DetailSection>
                    </DetailBox>
                    <DetailBox style={{width: "50%"}}>
                        <DetailSection style={{}}>
                            <img style={{position: "absolute", width: width * 0.33, marginTop: width <= 768 ? 10 : 35, marginLeft: width <= 768 ? 0 : -15}} alt="detail" src={require("../assets/images/Scene 03.png")}  />
                            <img style={{ width: width * 0.3}} alt="detail" src={require("../assets/images/tokenCircles.png")} />
                        </DetailSection>
                    </DetailBox>
                    </DetailBoxContainer>
                    :
                    <DetailBoxContainer>
                    <DetailBox>
                        <MainHeading>
                            Different parties can work together on the same project
                        </MainHeading>
                        <DetailSection>
                            <TokenDetailSection
                                description={"The entire transaction will be logged and displayed in the report. It will also be possible to export the record and sync is with your favorite spreadsheet."}
                            />
                            <TokenDetailSection
                                description={"Admins can invite multiple stakeholders, such as warehouse staff, suppliers and shippers, to share activity data and use the app with different permission levels."}
                            />
                            <TokenDetailSection
                                description={"Each transaction is created with a block to record immutable, values."}
                            />
                        </DetailSection>
                    </DetailBox>
                    <DetailBox style={{width: "50%"}}>
                        <DetailSection style={{}}>
                            <img style={{position: "absolute", width: width * 0.33, marginTop: width <= 768 ? height * 0.02 : height * 0.1, marginLeft: width <= 768 ? -5 : -15}} alt="detail" src={require("../assets/images/laptop-dark 2.png")}  />
                            <img style={{ width: width * 0.3}} alt="detail" src={require("../assets/images/tokenCircles.png")} />
                        </DetailSection>
                    </DetailBox>
                    </DetailBoxContainer>
            }
        </Container>
            
    </div>
  );
}

const Container = styled.div`
    display: flex;
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    margin-bottom: ${({width})=> width * 0.1}px;
    flex-direction: column;
    @media (max-width: 768px) {
        /* flex-direction: column; */
        
    }
`

const InnerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        
    }
   
`

const MainHeading = styled.p`
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 0px;
    color: ${colors.white};

    @media (max-width: 768px) {
        text-align: center;
        
    }
`

const DetailSection = styled.div`
    float: right;

    @media (max-width: 768px) {
        align-items: center;
    }   
`

const ButtonBar = styled.div`
    display: flex;
    width: auto;
    border-radius: 5px;
    border: 1px solid ${colors.btnPrimary};
    overflow: hidden;
    margin-top: ${({width})=> width * 0.05}px;
`

const ButtonBarSection = styled.button`
    width: 50%;
    text-align: center;
    padding: 10px;
    border: 0px;
`

const DetailBoxContainer = styled.div`
    display: flex;
    margin-top: 50px;

    @media (max-width: 768px) {
        flex-direction: column-reverse;
        width: 90%;
        align-items: center;
    }
`

const DetailBox = styled.div`
    width: 50%;
    @media (max-width: 768px) {
        width: 100%;
    }
`

const Btn = styled.button`
    background-color: transparent;
    border: 0px;
    font-size: 22px;
    align-items: center;
    color: ${colors.white};
    padding-top: 10px;
    
`


export default Eccosystem;
